
(function () {
  'use strict';
  if (window.DaLucaNylonLayoutLockV394) return;
  window.DaLucaNylonLayoutLockV394 = true;
  var desktopLayouts = new WeakSet();

  function important(el, prop, value) {
    if (el) el.style.setProperty(prop, value, 'important');
  }

  function clearDesktopLayout(root) {
    var steps = root.querySelector('.daluca-nylon-steps-v378');
    if (!steps || !desktopLayouts.has(steps)) return;
    desktopLayouts.delete(steps);
    ['display', 'grid-template-columns', 'column-gap', 'row-gap'].forEach(function(prop) {
      steps.style.removeProperty(prop);
    });
    steps.querySelectorAll(':scope > .daluca-nylon-step-v378').forEach(function(step) {
      ['grid-column', 'padding', 'width', 'min-width', 'overflow'].forEach(function(prop) {
        step.style.removeProperty(prop);
      });
      var body = step.querySelector(':scope > .daluca-concierge-step__body');
      if (body) ['width', 'min-width', 'padding-left', 'padding-right'].forEach(function(prop) {
        body.style.removeProperty(prop);
      });
    });
    var block = steps.querySelector('.daluca-nylon-step-v378--variants .product-form__input--block');
    if (block) ['display', 'grid-template-columns', 'gap', 'width'].forEach(function(prop) {
      block.style.removeProperty(prop);
    });
  }

  function applyColorRings(root) {
    var field = root.querySelector('.daluca-nylon-step-v378--variants .product-form__input--color');
    if (!field) return;

    important(field, 'display', 'grid');
    important(field, 'grid-template-columns', 'repeat(4,56px)');
    important(field, 'justify-content', 'center');
    important(field, 'gap', '11px 14px');
    important(field, 'max-width', '266px');
    important(field, 'margin', '0 auto');
    important(field, 'overflow', 'visible');

    field.querySelectorAll('input[type="radio"]').forEach(function(input) {
      var label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return;

      important(label, 'width', '56px');
      important(label, 'min-width', '56px');
      important(label, 'max-width', '56px');
      important(label, 'height', '56px');
      important(label, 'min-height', '56px');
      important(label, 'max-height', '56px');
      important(label, 'padding', '0');
      important(label, 'border-radius', '50%');
      important(label, 'border', input.checked ? '1px solid #223a56' : '1px solid #bcc5cc');
      important(label, 'background', 'transparent');
      important(label, 'overflow', 'hidden');
      important(label, 'transform', 'none');
      important(
        label,
        'box-shadow',
        input.checked
          ? '0 0 0 2px #fff, 0 0 0 4px #223a56'
          : '0 0 0 1px #fff, 0 0 0 2px #c5ccd2'
      );
    });
  }

  function applyDesktopLayout(root) {
    if (!window.matchMedia('(min-width:1068px)').matches) {
      clearDesktopLayout(root);
      return;
    }

    var steps = root.querySelector('.daluca-nylon-steps-v378');
    if (!steps) return;
    desktopLayouts.add(steps);

    important(steps, 'display', 'grid');
    important(
      steps,
      'grid-template-columns',
      'minmax(0,.9fr) minmax(0,1.15fr) minmax(0,1.2fr) minmax(0,1.05fr)'
    );
    important(steps, 'column-gap', '12px');
    important(steps, 'row-gap', '0');

    var fit = steps.querySelector('.daluca-nylon-step-v378--fit');
    var variants = steps.querySelector('.daluca-nylon-step-v378--variants');
    var addons = steps.querySelector('.daluca-nylon-step-v378--addons');
    var complete = steps.querySelector('.daluca-nylon-step-v378--complete');

    [[fit,'1'],[variants,'2'],[addons,'3'],[complete,'4']].forEach(function(pair) {
      var step = pair[0];
      if (!step) return;
      important(step, 'grid-column', pair[1]);
      important(step, 'padding', '20px');
      important(step, 'width', '100%');
      important(step, 'min-width', '0');
      important(step, 'overflow', 'visible');

      var body = step.querySelector(':scope > .daluca-concierge-step__body');
      if (body) {
        important(body, 'width', '100%');
        important(body, 'min-width', '0');
        important(body, 'padding-left', '0');
        important(body, 'padding-right', '0');
      }
    });

    if (variants) {
      var block = variants.querySelector('.product-form__input--block');
      if (block) {
        important(block, 'display', 'grid');
        important(block, 'grid-template-columns', 'repeat(5,minmax(0,1fr))');
        important(block, 'gap', '0');
        important(block, 'width', '100%');
      }
    }

    /* V4.09: add-on layout is intentionally NOT touched here.
       The old V3.94 code forced every add-on card to 132px with inline
       !important styles, overriding all later CSS and causing clipping.
       Width/color layout lock remains; add-ons are owned by the shared
       universal add-on stylesheet. */
  }

  function run() {
    var root = document.querySelector('.daluca-pdp--ready-nylon');
    if (!root) return;
    applyDesktopLayout(root);
    applyColorRings(root);
  }

  function schedule() {
    run();
    [60,180,450,900,1600].forEach(function(delay) {
      window.setTimeout(run, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', run, { passive: true });

  document.addEventListener('change', function(e) {
    if (e.target && e.target.closest && e.target.closest('.daluca-pdp--ready-nylon .product-form__input--color')) {
      window.setTimeout(run, 0);
    }
  });

  var observer = new MutationObserver(function() {
    window.clearTimeout(observer._dalucaTimer);
    observer._dalucaTimer = window.setTimeout(run, 40);
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class','style','checked']
  });
})();

